import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';

export const ACTIVITIES_ROUTE = {
  name: 'activities',
  route(classId: string): string[] {
    return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), this.name];
  },

  CURRICULUM: {
    name: 'curriculum',
    route(classId: string): string[] {
      return [...ACTIVITIES_ROUTE.route(classId), this.name];
    },
  },

  SHARED: {
    name: 'shared/:sharedFolderId/:folderId',
    route(classId: string, sharedFolderId: string, folderId: string): string[] {
      return [...ACTIVITIES_ROUTE.route(classId), 'shared', sharedFolderId, folderId];
    },
  },

  VISUAL: {
    name: 'visual',
    route(classId: string): string[] {
      return [...ACTIVITIES_ROUTE.route(classId), this.name];
    },
    ITEM: {
      name: ':featuredCategoryId',
      route(classId: string, featuredCategoryId: string): string[] {
        return [...ACTIVITIES_ROUTE.VISUAL.route(classId), featuredCategoryId];
      }
    }
  },

  CUSTOM: {
    name: 'custom',
    route(classId: string): string[] {
      return [...ACTIVITIES_ROUTE.route(classId), this.name];
    },
    ITEM: {
      name: 'custom/:folderId',
      route(classId: string, folderId: string): string[] {
        return [...ACTIVITIES_ROUTE.CUSTOM.route(classId), folderId];
      }
    }
	},

  BOOKMARKS: {
    name: 'bookmarks',
    route(classId: string): string[] {
      return [...ACTIVITIES_ROUTE.route(classId), this.name];
    },
  },

  PREASSESSMENTS: {
    name: 'preassessments',
    route(classId: string): string[] {
      return [...ACTIVITIES_ROUTE.route(classId), this.name];
    },
  },

  REPORTS: {
    name: 'reports',
    route(classId: string): string[] {
      return [...ACTIVITIES_ROUTE.route(classId), this.name];
    },
  },

  FEATURED: {
    name: 'featured/:featuredCategoryId',
    route(classId: string, featuredCategoryId: string): string[] {
      return [...ACTIVITIES_ROUTE.route(classId), 'featured', featuredCategoryId];
    },
  }
};
